import OrderFragment from './OrderFragment';
export default `
  query GetOrder($id: ID) {
    getOrder(id: $id) {
      ...OrderFragment
    }
  }
  ${OrderFragment}
`;
